<template>
  <fragment>
    <label>Upload Document:</label>
    <el-upload
        class="multi-upload"
        action=""
        multiple
        :limit="5"
        :on-remove="handleRemove"
        :file-list="fileList"
        :show-file-list="false"
        :auto-upload="false"
        :on-change="handleChange"
    >
      <el-button slot="trigger" size="small" type="primary">Select Files</el-button>
      <div class="el-upload__tip ml-sm-2 mb-1">You can upload up to 5 files</div>
    </el-upload>
    
    <div class="mt-3">
      <div v-for="(file, index) in fileList" :key="index" class="card mb-2 p-2" style="max-width: 300px; position: relative;">
        <button type="button" class="close" aria-label="Close" style="position: absolute; top: 5px; right: 10px;" @click="removeFile(file)">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="d-flex align-items-center">
           <div class="mr-3">
             <i class="el-icon-document" style="font-size: 2rem;"></i>
           </div>
           <div>
             <div class="text-truncate" style="max-width: 200px;" :title="file.name">{{ file.name }}</div>
             <div class="text-success small">
               <i class="el-icon-circle-check"></i> Selected
             </div>
           </div>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
import {File} from "@Views/Screening/utility/apiAgent";

export default {
  name: "MultiUpload",
  props: {
    uploadedFile: {
      type: Array
    },
    emailAddress: {
      type: String
    },
  },
  data() {
    {
      return {
        fileList: []
      }
    }
  },
  created() {
    this.$hub.$on('clear-uploaded-files', () => {
      this.fileList = [];
    });
  },
  methods: {
    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    submitUpload() {
      const promises = [];
      if (this.fileList.length === 0) {
        return Promise.resolve();
      }
      this.fileList.forEach(file => {
        const data = {files: file.raw, type: 'CommentDocument', email: this.emailAddress};
        const formData = new FormData;
        for (const [key, value] of Object.entries(data)) {
          formData.append(key, value);
        }
        promises.push(File.uploadDocument(formData));
      });
      return Promise.all(promises)
          .then((response) => {
            for (const responseElement of response) {
              this.uploadedFile.push({
                id: responseElement.data.data[0].id,
                name: responseElement.data.data[0].file_name,
                fileURL: responseElement.data.data[0].file_path,
              });
            }
            this.fileList = []; // Clear the list after successful upload
            this.$toastr.s('Files uploaded successfully');
            this.$emit('uploaded');
          });
    },
    removeFile(file) {
      const index = this.fileList.indexOf(file);
      if (index !== -1) {
        this.fileList.splice(index, 1);
      }
    }
  }
}
</script>

<style scoped>
.multi-upload {
  display: flex;
  align-items: center;
}
</style>